export const isAssignableFoodRunRecipient = (recipient) =>
  Boolean(recipient) && Number(recipient.pending_approval) !== 1;
